import moment from "moment";
import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { Modal, Button, Alert, Form, Label, Input } from "@/Components/Common/Tailwind";
import { ticketService } from "../../api/services/ticket.service";

interface AmazingPassInfo {
  precoupon_name?: string;
  coupon_start_date?: string;
  coupon_end_date?: string;
  available_package_names?: { name: string; site: string }[];
  description?: string;
  transfered_ticket?: { id: number };
}

interface AmazingPassInfoModalProps {
  info: AmazingPassInfo;
  setInfo: (info: AmazingPassInfo | {}) => void;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  refetch: () => void;
}

const AmazingPassInfoModal = ({ info, setInfo, visible, setVisible, refetch }: AmazingPassInfoModalProps) => {
  const togModal = () => {
    setVisible(!visible);
  };

  const handleRefund = async (couponData: AmazingPassInfo) => {
    if (!couponData?.transfered_ticket) return;

    const confirmed = window.confirm("환불하시겠습니까?");

    if (confirmed) {
      try {
        await ticketService.requestTicketCancel(couponData.transfered_ticket.id);
        setVisible(false);
        setInfo({});
        refetch();
      } catch (error: any) {
        console.log("requestTicketCancel", error);
        if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else {
          toast.error("환불에 실패했습니다.");
        }
      }
    }
  };

  return (
    <React.Fragment>
      {Object.keys(info).length !== 0 ? (
        <Modal toggle={togModal} isOpen={visible} centered>
          <div className="space-y-3">
            {/* 쿠폰 이름 */}
            <div className="animate-in fade-in-0 slide-in-from-bottom-2 duration-300 [animation-fill-mode:both]">
              <p className="text-xs font-medium text-muted-foreground">쿠폰 이름</p>
              <h5 className="mt-1 text-lg font-bold text-balance break-keep leading-snug">
                {info?.precoupon_name}
              </h5>
            </div>

            {/* 예약 가능 기간 */}
            <div className="rounded-xl bg-muted px-4 py-3 animate-in fade-in-0 slide-in-from-bottom-2 duration-300 [animation-delay:75ms] [animation-fill-mode:both]">
              <p className="text-xs font-medium text-muted-foreground">예약 가능 기간</p>
              <p className="mt-1 font-semibold tabular-nums tracking-tight">
                {info.coupon_start_date} ~ {info.coupon_end_date}
              </p>
            </div>

            {/* 사용 가능 패키지 */}
            <div className="rounded-xl bg-muted px-4 py-3 animate-in fade-in-0 slide-in-from-bottom-2 duration-300 [animation-delay:150ms] [animation-fill-mode:both]">
              <p className="mb-2 text-xs font-medium text-muted-foreground">사용 가능 패키지</p>
              <ul className="max-h-[140px] space-y-1.5 overflow-y-auto pr-1">
                {info?.available_package_names?.map((item, idx) => (
                  <li key={idx} className="text-sm break-keep">
                    <span className="font-medium text-foreground">{item.name}</span>
                    <span className="ml-1 text-xs text-muted-foreground">({item.site})</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* 안내사항 (내용이 있을 때만) */}
            {info.description?.trim() ? (
              <div className="rounded-xl bg-muted px-4 py-3 animate-in fade-in-0 slide-in-from-bottom-2 duration-300 [animation-delay:225ms] [animation-fill-mode:both]">
                <p className="mb-1.5 text-xs font-medium text-muted-foreground">안내사항</p>
                <div
                  className="max-h-[180px] overflow-y-auto text-left text-xs leading-relaxed text-pretty break-keep"
                  dangerouslySetInnerHTML={{ __html: info.description }}
                />
              </div>
            ) : null}
          </div>
          <div className="flex justify-center gap-3 mt-5">
            {info?.transfered_ticket ? (
              <Button
                variant="secondary"
                className="flex-1 min-h-[44px] transition active:scale-[0.96]"
                onClick={() => {
                  handleRefund(info);
                }}
              >
                환불하기
              </Button>
            ) : null}

            <Button
              variant="primary"
              className="flex-1 min-h-[44px] transition active:scale-[0.96]"
              onClick={() => {
                setInfo({});
                setVisible(false);
              }}
            >
              닫기
            </Button>
          </div>
        </Modal>
      ) : null}
    </React.Fragment>
  );
};
export default AmazingPassInfoModal;
